var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbbLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 30,
    viewBox: "0 0 78 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5205 29.9991H44.3302C49.7595 29.7264 53.5599 25.4538 53.5599 20.363C53.5599 18.6358 53.198 16.9085 52.3836 15.5449H42.5205V29.9991Z",
    fill: "#FF000F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6268 15.4551H32.5781V30.0002H41.6268V15.4551Z",
    fill: "#FF000F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8407 14.5451C50.9358 13.2724 49.669 12.2724 48.3117 11.5452C49.9404 10.3634 51.0263 8.45434 51.0263 6.36348C51.0263 2.81811 48.2212 0 44.6922 0H42.5205V14.5451H51.8407Z",
    fill: "#FF000F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6268 0H32.5781V14.5451H41.6268V0Z",
    fill: "#FF000F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9609 29.9991H68.7707C74.1999 29.7264 78.0004 25.4538 78.0004 20.363C78.0004 18.6358 77.6384 16.9085 76.824 15.5449H66.9609V29.9991Z",
    fill: "#FF000F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0507 15.4551H57.002V30.0002H66.0507V15.4551Z",
    fill: "#FF000F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2811 14.5451C75.3762 13.2724 74.1094 12.2724 72.7521 11.5452C74.3809 10.3634 75.4667 8.45434 75.4667 6.36348C75.4667 2.81811 72.6616 0 69.1326 0H66.9609V14.5451H76.2811Z",
    fill: "#FF000F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0507 0H57.002V14.5451H66.0507V0Z",
    fill: "#FF000F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15776 15.4551L0 30.0002H7.51043L9.68211 23.6367H14.4779V15.4551H5.15776Z",
    fill: "#FF000F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4735 0H10.5826L5.4248 14.5451H14.4735V0Z",
    fill: "#FF000F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.373 23.6367H20.1689L22.3405 30.0002H29.851L24.6932 15.4551H15.373V23.6367Z",
    fill: "#FF000F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4218 14.5451L19.264 0H15.373V14.5451H24.4218Z",
    fill: "#FF000F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbbLogo);
export default __webpack_public_path__ + "static/media/ABB-logo.54bb4b7d585389712e8264d4e3a85749.svg";
export { ForwardRef as ReactComponent };